import { cerrarSesionLocal, refrescarSesion } from '@/shared/api/authBridge';
import { usuariosApi } from '@/shared/api/services/usuariosApi';
import { clearPrivateQueries } from '@/shared/hooks/queryCache';
import { setUser } from '../slices/authSlice';
import type { AppStoreLike } from './types';

/**
 * Al arrancar con una sesión recordada (refresh token persistido, o modo cookie) renueva la sesión y trae
 * el perfil. Un fallo de RED no cierra la sesión: se reintenta al volver la conexión. Un refresh inválido
 * o reutilizado sí la cierra (con un aviso discreto si había un usuario recordado).
 */
export async function arrancarSesion(store: AppStoreLike): Promise<void> {
  const { auth, mercado } = store.getState();
  const cookie = mercado.capacidades?.data.auth.cookieMode ?? false;
  if (auth.status === 'auth' || (!auth.refreshToken && !cookie)) return;
  const hadUser = auth.user !== null;

  const resultado = await refrescarSesion(store);
  if (resultado === 'invalida') {
    cerrarSesionLocal(store, hadUser);
    return;
  }
  if (resultado !== 'ok') return;
  const yo = await usuariosApi.getYo();
  if (yo.ok) store.dispatch(setUser(yo.data));
}

/**
 * Arranca la sesión recordada, la reintenta al recuperar la conexión y limpia las cachés privadas
 * (alertas, notificaciones, sesiones) cuando la sesión se cierra. Devuelve cómo detenerlo.
 */
export function startAuthBootstrap(store: AppStoreLike): () => void {
  let estabaAutenticado = store.getState().auth.status === 'auth';
  let sinRed = store.getState().ui.offline;
  void arrancarSesion(store);

  return store.subscribe(() => {
    const s = store.getState();
    const autenticado = s.auth.status === 'auth';
    if (estabaAutenticado && !autenticado) clearPrivateQueries();
    estabaAutenticado = autenticado;
    if (sinRed && !s.ui.offline) void arrancarSesion(store);
    sinRed = s.ui.offline;
  });
}
